import { Drawer, Tabs, Typography, Switch, Spin, Button } from 'antd'
import styled from 'styled-components'
import { SignTitle } from '@/components/sign-title'
import { IconFont, SvgIcon, TagDetail } from '@/components'
import MarkdownEditor from '@/components/markdown-editor'
import DetailLog from './detail-log'
import DownloadModal from '../create-task/download-modal'
import { useState } from 'react'
import ExecutionProcessTree from './execution-process-tree'
import { t } from '@/i18n'
const { Paragraph, Text } = Typography

export const DetailDrawer = props => {
  const { visible = true, onClose, dataList, logList = [], loading } = props
  const [downloadModalVisible, setDownloadModalVisible] = useState({
    resourceId: '',
    sha256: '',
    visible: false,
  })
  const [executionProcessTreeVisible, setExecutionProcessTreeVisible] = useState(false)

  const BasicInfo = () => (
    <DetailDrawerBox>
      {loading ? (
        <Spin />
      ) : (
        <>
          <div className="flex">
            <p className="title">{t('用例名称：')}</p>
            <div style={{ lineHeight: '1.8em', marginTop: '-5px' }}>{dataList?.plugin_name}</div>
          </div>
          <div className="flex">
            <p className="title">{t('模板名称：')}</p>
            <div style={{ lineHeight: '1.8em', marginTop: '-5px' }}>
              {dataList?.template_name?.map((item, index) => (
                <Text ellipsis={{ tooltip: true }} style={{ maxWidth: 250 }} key={index}>
                  {item}
                  {index !== dataList?.template_name?.length - 1 && '，'}
                </Text>
              ))}
            </div>
          </div>
          <div className="flex">
            <p className="title">{t('验证模式：')}</p>
            <div style={{ lineHeight: '1.8em', marginTop: '-5px' }}>
              {dataList?.verification_mode_id === '1' ? (
                <span>
                  agent
                  <SvgIcon
                    name="箭头_向右"
                    width={14}
                    height={14}
                    style={{ margin: '0 2px', verticalAlign: 'middle' }}
                  />
                  agent
                </span>
              ) : dataList?.verification_mode_id === '2' ? (
                <span>
                  {t('Web攻击机')}
                  <SvgIcon
                    name="箭头_向右"
                    width={14}
                    height={14}
                    style={{ margin: '0 2px', verticalAlign: 'middle' }}
                  />
                  {t('Web应用')}
                </span>
              ) : dataList?.verification_mode_id === '4' ? (
                <span>
                  Agent
                  <SvgIcon
                    name="箭头_向右"
                    width={14}
                    height={14}
                    style={{ margin: '0 2px', verticalAlign: 'middle' }}
                  />
                  {t('主机')}
                </span>
              ) : dataList?.verification_mode_id === '5' ? (
                <span>
                  Agent
                  <SvgIcon
                    name="箭头_向右"
                    width={14}
                    height={14}
                    style={{ margin: '0 2px', verticalAlign: 'middle' }}
                  />
                  {t('容器')}
                </span>
              ) : dataList?.verification_mode_id === '10' ? (
                <span>
                  {t('容器')}
                  <SvgIcon
                    name="箭头_向右"
                    width={14}
                    height={14}
                    style={{ margin: '0 2px', verticalAlign: 'middle' }}
                  />
                  Listener
                </span>
              ) : dataList?.verification_mode_id === '6' ? (
                <span>
                  Agent
                  <SvgIcon
                    name="箭头_向右"
                    width={14}
                    height={14}
                    style={{ margin: '0 2px', verticalAlign: 'middle' }}
                  />
                  {t('外部情报')}
                </span>
              ) : dataList?.verification_mode_id === '7' ? (
                <span>
                  Agent
                  <SvgIcon
                    name="箭头_向右"
                    width={14}
                    height={14}
                    style={{ margin: '0 2px', verticalAlign: 'middle' }}
                  />
                  {t('外部情报')}
                </span>
              ) : dataList?.verification_mode_id === '8' ? (
                <span>
                  {t('平台')}
                  <SvgIcon
                    name="箭头_向右"
                    width={14}
                    height={14}
                    style={{ margin: '0 2px', verticalAlign: 'middle' }}
                  />
                  {t('邮箱')}
                </span>
              ) : dataList?.verification_mode_id === '9' ? (
                <span>
                  Agent
                  <SvgIcon
                    name="箭头_向右"
                    width={14}
                    height={14}
                    style={{ margin: '0 2px', verticalAlign: 'middle' }}
                  />
                  Listener
                </span>
              ) : (
                '-'
              )}
            </div>
          </div>
          <div className="flex">
            <p className="title">{t('拦截状态：')}</p>
            {dataList?.intercept_status === 1 && <div className="intercept">{t('拦截成功')}</div>}
            {dataList?.intercept_status === 2 && (
              <div className="intercept-err">{t('防护失效')}</div>
            )}
            {dataList?.intercept_status === 3 && (
              <div className="intercept-err" style={{ color: '#72b851', background: '#e9f5e3' }}>
                {t('检测成功')}
              </div>
            )}
            {dataList?.intercept_from === 'interception_from_manual_correct' && (
              <span
                style={{
                  display: 'inline-block',
                  width: '48px',
                  height: '18px',
                  background: 'rgba(0, 180, 42, 0.15)',
                  borderRadius: '9px',
                  fontWeight: 400,
                  fontSize: '12px',
                  color: '#00B42A',
                  textAlign: 'center',
                  lineHeight: '18px',
                  marginLeft: '8px',
                  marginTop: '2px',
                }}
              >
                {t('已修正')}
              </span>
            )}
          </div>
          <div className="flex">
            <p className="title">{t('危险等级：')}</p>
            {dataList?.risk_level === 1 && t('低危')}
            {dataList?.risk_level === 2 && t('中危')}
            {dataList?.risk_level === 3 && t('高危')}
            {dataList?.risk_level === 4 && t('严重')}
          </div>
          {dataList?.resource_tag_list && dataList?.resource_tag_list?.length > 0 && (
            <TagDetail resourceTagList={dataList?.resource_tag_list || []} />
          )}
          <div className="flex">
            <p className="title">{t('攻击类型：')}</p>
            <p className="name">{dataList?.attack_name || '-'}</p>
          </div>
          {dataList?.params && dataList?.params?.length > 0 && (
            <div className="flex" style={{ flexDirection: 'column' }}>
              <div className="title" style={{ width: 100, marginBottom: 8 }}>
                {t('用例参数配置：')}
              </div>
              <div className="params">
                {/* <div className="os">Windows</div> */}
                {dataList?.params?.map((item, index) => (
                  <div className="params-flex" key={index}>
                    <Typography.Text
                      className="params-title"
                      ellipsis={{ tooltip: true, suffix: ':' }}
                    >
                      {item?.key}
                    </Typography.Text>
                    <div className="content">
                      {item.type === 'bool' ? (
                        <Switch
                          style={{ marginBottom: 8 }}
                          checked={item.value === 'true'}
                          disabled
                        />
                      ) : item.type === 'password' ? (
                        <div style={{ marginBottom: 8 }}>●●●●●●●●</div>
                      ) : (
                        <div style={{ marginBottom: 8 }}>
                          {item.value && item.type === 'file' && <IconFont type={'icon-fujian2'} />}
                          {item.value || '-'}
                        </div>
                      )}
                      <Paragraph
                        className="describe"
                        style={{
                          marginBottom: index + 1 === dataList?.params?.length && 0,
                        }}
                      >
                        {item.description}
                      </Paragraph>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          )}
          <div className="flex" style={{ alignItems: 'center' }}>
            <p className="title">{t('更新时间：')}</p>
            <div>{dataList?.update_time?.substring(0, 10)}</div>
          </div>
          <div className="flex" style={{ alignItems: 'center' }}>
            <p className="title">{t('平台架构：')}</p>
            <div>
              {dataList?.supported_architectures?.map((item, index) => (
                <span style={{ marginRight: '8px' }} key={index}>
                  {item == '1' ? 'X86' : 'ARM'}
                </span>
              ))}
            </div>
          </div>
          <div className="flex" style={{ alignItems: 'center' }}>
            <div className="title">{t('操作系统：')}</div>
            <div>
              {dataList?.supported_platforms?.includes('1') && <SvgOs name="windows" />}
              {dataList?.supported_platforms?.includes('3') && <SvgOs name="linux" />}
              {dataList?.supported_platforms?.includes('4') && <SvgOs name="UOS" />}
            </div>
          </div>
          {dataList?.tactic_list && dataList?.tactic_list?.length > 0 && (
            <div className="flex" style={{ marginBottom: 0 }}>
              <div className="title" style={{ marginRight: 18 }}>
                ATT&CK：
              </div>
              <div style={{ width: 'calc(100% - 112px)' }}>
                {dataList?.tactic_list?.map((item, index) => (
                  <div className="att-text" key={index} style={{ marginBottom: 8 }}>
                    <a href={item.url} target="_blank" rel="noopener noreferrer">
                      {item?.name}
                    </a>
                  </div>
                ))}
              </div>
            </div>
          )}
          {dataList?.describe && (
            <div className="block">
              <p className="title">{t('用例描述：')}</p>
              <MarkdownEditor
                isEdit={false}
                onlyDisplay
                setValue={() => {}}
                value={dataList?.describe}
              />
            </div>
          )}

          {dataList?.solution && (
            <div className="block">
              <p className="title">{t('解决方案：')}</p>
              <MarkdownEditor
                isEdit={false}
                onlyDisplay
                setValue={() => {}}
                value={dataList?.solution}
              />
            </div>
          )}
        </>
      )}
    </DetailDrawerBox>
  )

  const AttackDetail = () => (
    <DetailDrawerBox>
      {loading ? (
        <Spin />
      ) : (
        <>
          {dataList?.samples_list && dataList?.samples_list?.length > 0 && (
            <div className="flex" style={{ flexDirection: 'column' }}>
              <p className="title">{t('样本文件：')}</p>
              <div className="params" style={{ padding: 0 }}>
                {dataList?.samples_list?.map(item => (
                  <div className="sample" key={item.id}>
                    <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                      <div style={{ display: 'flex', alignItems: 'center' }}>
                        <IconFont type="icon-047-file" />
                        <span>&nbsp;{item.samples_name}</span>
                      </div>
                      <Button
                        type="link"
                        icon={<IconFont type="icon-xiazai2" />}
                        onClick={() =>
                          setDownloadModalVisible({
                            resourceId: dataList?.plugin_id,
                            sha256: item.samples_sha256,
                            visible: true,
                          })
                        }
                      >
                        {t('下载')}
                      </Button>
                    </div>
                    <div
                      style={{
                        fontSize: 12,
                        display: 'flex',
                        marginTop: 10,
                      }}
                    >
                      <div className="title">SHA-256：</div>
                      <div
                        style={{
                          width: 'calc(100% - 70px)',
                          wordWrap: 'break-word',
                          wordBreak: 'break-all',
                        }}
                      >
                        {item.samples_sha256}
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          )}
          <div className="flex" style={{ alignItems: 'center' }}>
            <p className="title" style={{ width: 100 }}>
              {t('执行开始时间：')}
            </p>
            <div className="text" style={{ width: 'calc(100% - 100px' }}>
              {dataList?.start_time}
            </div>
          </div>
          <div className="flex" style={{ alignItems: 'center' }}>
            <p className="title" style={{ width: 100 }}>
              {t('执行结束时间：')}
            </p>
            <div className="text" style={{ width: 'calc(100% - 100px' }}>
              {dataList?.end_time}
            </div>
          </div>
          {dataList?.event_detail && (
            <>
              {dataList?.event_detail?.map(item => (
                <>
                  <div className="flex" style={{ flexDirection: 'column' }}>
                    <p className="title" style={{ marginBottom: 8 }}>
                      {t('进程信息：')}
                    </p>
                    <div
                      style={{
                        display: 'flex',
                        flexDirection: 'column',
                        background: '#F8F9FB',
                        borderRadius: 6,
                        padding: '10px 12px',
                        paddingBottom: 0,
                      }}
                    >
                      <div className="flex">
                        <p className="title">PID：</p>
                        <div className="text">{item?.pid || '-'}</div>
                      </div>
                      <div className="flex">
                        <p className="title">PName：</p>
                        <div className="text">{item?.pname || '-'}</div>
                      </div>
                    </div>
                  </div>
                  <div className="flex" style={{ flexDirection: 'column' }}>
                    <p className="title" style={{ marginBottom: 8 }}>
                      {t('文件hash值：')}
                    </p>
                    <div
                      style={{
                        display: 'flex',
                        flexDirection: 'column',
                        background: '#F8F9FB',
                        borderRadius: 6,
                        padding: '10px 12px',
                        paddingBottom: 0,
                      }}
                    >
                      <div className="flex">
                        <p className="title">sha1：</p>
                        <div className="text">{item?.sha1 || '-'}</div>
                      </div>
                      <div className="flex">
                        <p className="title">MD5：</p>
                        <div className="text">{item?.md5 || '-'}</div>
                      </div>
                      <div className="flex">
                        <p className="title">sha256：</p>
                        <Typography.Text
                          ellipsis
                          className="text"
                          style={{ width: 'calc(100% - 70px)' }}
                        >
                          {item?.sha256 || '-'}
                        </Typography.Text>
                      </div>
                    </div>
                  </div>
                </>
              ))}
            </>
          )}
          {dataList?.plugin_log && (
            <div className="flex" style={{ flexDirection: 'column' }}>
              <p
                className="title"
                style={{
                  width: '100%',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'space-between',
                }}
              >
                <span>{t('执行日志：')}</span>
                <Button
                  type="primary"
                  size="small"
                  onClick={() => setExecutionProcessTreeVisible(true)}
                >
                  {t('ETW进程树分析')}
                </Button>
              </p>
              <div className="content" style={{ width: '100%', marginTop: 15 }}>
                {dataList?.plugin_log?.split('\n')?.map((item, i) => (
                  <div key={i}>{item}</div>
                ))}
              </div>
            </div>
          )}
          <DownloadModal
            visible={downloadModalVisible.visible}
            resourceId={downloadModalVisible.resourceId}
            sha256={downloadModalVisible.sha256}
            onClose={() => setDownloadModalVisible({ resourceId: '', sha256: '', visible: false })}
          />

          <ExecutionProcessTree
            log={dataList?.plugin_log}
            visible={executionProcessTreeVisible}
            onCancel={() => setExecutionProcessTreeVisible(false)}
          />
        </>
      )}
    </DetailDrawerBox>
  )

  const LogDetail = () => (
    <DetailDrawerBox>
      {loading ? (
        <Spin />
      ) : (
        <div className="log-alarm">
          <div className="log-alarm-title" style={{ marginBottom: 10 }}>
            {t('告警日志：')}
          </div>
          {logList?.map((item, index) => (
            <DetailLog index={index} data={item} key={index} />
          ))}
        </div>
      )}
    </DetailDrawerBox>
  )

  return (
    <DetailDrawerContainer>
      <Drawer
        title={<SignTitle show>{t('用例详情')}</SignTitle>}
        placement="right"
        closable
        onClose={onClose}
        visible={visible}
        width={600}
        destroyOnClose
      >
        <Tabs
          defaultActiveKey="1"
          items={
            logList.length > 0
              ? [
                  { label: t('用例信息'), key: '1', children: <BasicInfo /> },
                  { label: t('攻击详情'), key: '2', children: <AttackDetail /> },
                  { label: t('告警日志'), key: '3', children: <LogDetail /> },
                ]
              : [
                  { label: t('用例信息'), key: '1', children: <BasicInfo /> },
                  { label: t('攻击详情'), key: '2', children: <AttackDetail /> },
                ]
          }
        />
      </Drawer>
    </DetailDrawerContainer>
  )
}

const DetailDrawerContainer = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
`

const DetailDrawerBox = styled.div`
  .block {
    margin: 12px 0;
    .title {
      font-size: 14px;
      color: #86909c;
      line-height: 16px;
      width: 92px;
      text-align: left;
      margin-right: 18px;
      white-space: nowrap;
    }
  }
  .intercept,
  .intercept-err {
    width: 64px;
    height: 20px;
    background: #e5eeff;
    border-radius: 4px 12px 4px 12px;
    font-size: 12px;
    color: #2973ff;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .intercept-err {
    color: #f44f4f;
    background: #fde5e5;
  }
  .content {
    word-break: break-all;
    color: #666666;
    border-radius: 4px;
    .headers {
      display: flex;
      margin-bottom: 5px;
    }
    .marked {
      white-space: nowrap;
      color: #558490;
      margin-right: 5px;
    }
    .marked-body {
      color: #558490;
    }
  }
  .header {
    // max-height: 200px;
    overflow-y: auto;
  }
  .flex,
  .flex-name {
    display: flex;
    margin-bottom: 15px;
    .content {
      color: #666666;
      border-radius: 4px;
      padding: 0 10px;
      width: calc(98% - 128px);
      background: #f7f8fa;
    }
    .title {
      height: 14px;
      font-size: 14px;
      color: #86909c;
      line-height: 16px;
      width: 92px;
      text-align: left;
      white-space: nowrap;
      margin-bottom: 0px;
    }
    .name {
      flex: 1;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
    }
  }
  .flex-name {
    width: 50%;
  }
  .flex-two {
    display: flex;
    .title {
      height: 14px;
      font-size: 14px;
      color: #86909c;
      line-height: 16px;
      width: 92px;
      text-align: left;
      margin-right: 18px;
      white-space: nowrap;
    }

    .name {
      width: 55%;
    }
  }
  .params {
    width: 100%;
    background: #f8f9fb;
    border-radius: 6px;
    padding: 12px;
    margin-top: 8px;
    .sample {
      border-top: 1px dashed #d5d9dd;
      padding: 10px;
      &:first-child {
        border: 0;
      }
    }
  }
  .params-flex {
    display: flex;
  }
  .params-title {
    height: 20px;
    width: 106px;
  }
`

const SvgOs = styled(SvgIcon)`
  width: 32px;
  height: 32px;
  margin-right: 10px;
`
